let _ = t => t,
  _t;
import styled from 'styled-components';
export const Header = styled.header(_t || (_t = _`
    display: flex;
    flex-direction: column;
    gap: 4px;

    width: 100%;

    & > * {
        margin: 0;
    }
`));